import styles from "./modalInbox.module.css"
import Modal from "../index"
import Button from "../../Form/Button"
import FormGroup from "../../Form/FormGroup"
import BreakForm from "../../Form/BreakForm"
import { MdOutlineWhatsapp } from "react-icons/md"
import { TbReload } from "react-icons/tb"

const ModalWhatsAppLiteConnection = ({ inbox = {}, getQRCodeByConnect = () => { }, closeModal = () => { } }) => {
    const isDisconnected = inbox?.status === "disconnected"
    const hasQrCode = Boolean(inbox?.qrCode?.base64)
    const qrExpired = Boolean(inbox?.qrCode?.expired)

    const handleGenerateQrCode = (e) => {
        e.preventDefault()
        getQRCodeByConnect(inbox._id)
    }

    return (
        <Modal
            icon={<MdOutlineWhatsapp />}
            title="Conectar WhatsApp Lite"
            description={inbox?.name || "Conecte uma caixa de entrada pelo WhatsApp Web"}
            closeModal={closeModal}
            heightFitContent={true}
        >
            <form onSubmit={(e) => e.preventDefault()}>
                <BreakForm title="Status da conexão" showAction={false} border={false} />
                <FormGroup labelText="Status">
                    <span>{isDisconnected ? "Desconectado" : "Conectado"}</span>
                </FormGroup>
                {isDisconnected ?
                    <>
                        <BreakForm title="Como conectar" showAction={false} />
                        <FormGroup>
                            <ol className={styles.connectionSteps}>
                                <li>Abra o WhatsApp no celular que será usado nesta caixa.</li>
                                <li>Toque em Aparelhos conectados.</li>
                                <li>Toque em Conectar um aparelho.</li>
                                <li>Escaneie o QR Code exibido aqui.</li>
                            </ol>
                        </FormGroup>
                        {hasQrCode ?
                            <div className={styles.groupQrCode}>
                                <div className={styles.qrCode}>
                                    {qrExpired ?
                                        <TbReload className={styles.reload} onClick={() => getQRCodeByConnect(inbox._id)} />
                                        :
                                        <img src={inbox.qrCode.base64} alt="QR Code do WhatsApp Lite" />
                                    }
                                </div>
                                <span>{qrExpired ? "QR Code expirado. Clique no ícone para gerar um novo." : "Escaneie o QR Code antes que ele expire."}</span>
                            </div>
                            :
                            <FormGroup>
                                <Button variant="primary" onClick={handleGenerateQrCode}>Gerar QR Code</Button>
                            </FormGroup>
                        }
                    </>
                    :
                    <FormGroup>
                        <span>Esta caixa já está conectada. Para trocar o aparelho, desconecte a caixa e conecte novamente.</span>
                    </FormGroup>
                }
            </form>
        </Modal>
    )
}

export default ModalWhatsAppLiteConnection
